var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":_vm.$t('Purchase discounts'),"description":_vm.$t('From here you can control the purchase discounts')}}),_c('indexTable',{attrs:{"searchText":_vm.$t('Find a purchase discount'),"emptyTableText":_vm.$t('There are no purchase discounts'),"buttonRole":_vm.$checkRole('purchase_discounts_add'),"emptyTableSubText":_vm.$t('Try adding some items to the table and try again'),"statusSearch":true,"statusValues":[
          { title: _vm.$t('Situation'), value: '' },
          { title: _vm.$t('All'), value: '' },
          { title: _vm.$t('Draft'), value: 0 },
          { title: _vm.$t('Approved'), value: 1 }
        ],"cloumns":[
          {
            column: 'code',
            title: _vm.$t('Discount'),
            type: 'mainLink',
            sort: true
          },
          {
            column: 'client_type',
            title: _vm.$t('Supplier name'),
            type: 'clintLink',
            sort: true
          },
          {
            column: 'date',
            title: _vm.$t('Date'),
            type: 'text',
            sort: true
          },
          {
            column: 'description',
            title: _vm.$t('Thats about'),
            type: 'text',
            sort: true
          },
          {
            column: 'cost',
            title: _vm.$t('Amount'),
            type: 'text',
            sort: true
          },
          {
            column: 'user_name',
            title: _vm.$t('Responsible name'),
            type: 'text',
            sort: true
          },
          {
            column: 'status',
            title: _vm.$t('Situation'),
            type: 'status',
            sort: true,
            values: [
              { title: _vm.$t('Draft'), value: 0, color: 'dark' },
              { title: _vm.$t('Approved'), value: 1, color: 'success' }
            ]
          },

          {
            column: 'options',
            title: _vm.$t('Settings'),
            type: 'options',
            options: [
              { name: 'show' },
              { name: 'printPurchaseDiscount', role: true },
              {
                name: 'edit',
                role: _vm.$checkRole('purchase_discounts_edit')
              },
              { name: 'file' },
              {
                name: 'delete',
                role: _vm.$checkRole('purchase_discounts_delete')
              }
            ]
          }
        ],"deleteText":{
          attention: _vm.$t('Attention'),
          areYouReallySureToDeleteTheItem: _vm.$t('Are you really sure to delete the item'),
          close: _vm.$t('Close'),
          confirm: _vm.$t('Confirm'),
          loading: _vm.$t('Loading')
        }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }